import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { AuthService } from '#core/components/auth/auth.service';

@Injectable()
export class AuthGuard {
    private readonly _authService = inject(AuthService);
    private readonly _router = inject(Router);

    canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        if (!this._authService.isAuthenticated()) {
            this._authService.setRedirectUrl(state.url);
            return this._router.createUrlTree(['auth', 'login']);
        }

        this._authService.setRedirectUrl(null);
        return true;
    }
}
